import React, { useState, useEffect } from 'react';

const greetings = [
  'Hola',
  'Hello', 
  'Bonjour',
  'Ciao',
  'Hallo',
  'Olá',
  'Привет',
  '你好',
  'こんにちは',
  'مرحبا'
];

const SplashScreen = ({ onComplete }) => {
  const [greetingIndex, setGreetingIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Change greeting every 300ms
    const greetingInterval = setInterval(() => {
      setGreetingIndex((prev) => (prev + 1) % greetings.length);
    }, 300);

    // Hide splash screen after 2 seconds
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        onComplete();
      }, 500); // Wait for fade out animation
    }, 2000);

    return () => {
      clearInterval(greetingInterval);
      clearTimeout(timer);
    };
  }, [onComplete]);

  return (
    <div 
      className={`fixed inset-0 bg-black z-50 flex items-center justify-center transition-opacity duration-500 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <h1 className="text-6xl md:text-8xl lg:text-9xl font-light text-white animate-pulse">
        {greetings[greetingIndex]}
      </h1>
    </div>
  );
};

export default SplashScreen;
